const pt = {
    configureNewClients: 'Configurar novos clientes',
    showDemo: 'Ver resumo de demonstração',
    summaryDemo: 'Resumo financeiro de demonstração — valores simulados.',
    demonstration: 'Demonstração',
    toReview: 'Para analisar',
    sentPayroll: 'Enviadas à Folha',
    attention: 'Atenção',
    critical: 'Crítico',
    insight: 'Insight',
    notice: 'Demonstração: dados e ações simulados. Nenhuma operação externa será realizada.',
    users: 'Usuários do Escritório',
    usersCount: 'usuários cadastrados',
    newUser: 'Novo usuário',
    name: 'Nome',
    fullName: 'Nome completo',
    cpf: 'CPF',
    email: 'E-mail',
    phone: 'Telefone',
    cancel: 'Cancelar',
    save: 'Salvar',
    close: 'Fechar',
    saved: 'Usuário cadastrado na demonstração.',
    invalidUser: 'Informe nome, CPF com 11 dígitos e e-mail válido.',
    company: 'Empresa',
    city: 'Cidade',
    status: 'Status',
    actions: 'Ações',
    search: 'Buscar por nome ou CNPJ…',
    invite: 'Convidar',
    resend: 'Reenviar',
    configure: 'Configurar',
    notInvited: 'Não convidada',
    invited: 'Convite enviado',
    active: 'Ativa',
    accountingInfo: 'Aqui são listadas apenas as empresas já cadastradas no Contábil. Caso a empresa não apareça nesta lista, faça o cadastro pelo Domínio Contábil em Controle / Empresas e depois volte para enviar o convite.',
    inviteStep: 'Passo 1 — Convite',
    configurationStep: 'Passo 2 — Configuração',
    sendInvite: 'Enviar convite',
    legalName: 'Nome do responsável legal',
    invalidInvite: 'Preencha CPF, nome, e-mail e telefone do responsável legal.',
    invitationSent: 'Convite simulado. Nenhum e-mail foi enviado.',
    waitConfirmation: 'Após a confirmação do responsável legal, configure a empresa no Domínio Empresa.',
    noResults: 'Nenhuma empresa encontrada.',
    client: 'Cliente',
    all: 'Todos',
    select: 'Selecione',
    newAdmission: 'Nova admissão',
    admissionDescription: 'Inicie a admissão em nome de uma empresa cliente. O colaborador preenche os dados no aplicativo e o retorno chega aqui, pronto para a Folha.',
    clientCompany: 'Empresa cliente',
    type: 'Tipo de admissão',
    employee: 'Empregado',
    contributor: 'Contribuinte',
    intern: 'Estagiário',
    optionalEmail: 'E-mail (opcional)',
    payment: 'Forma de pagamento',
    pix: 'Pix',
    account: 'Conta bancária',
    cash: 'Dinheiro',
    observation: 'Observação para o colaborador',
    invalidAdmission: 'Selecione a empresa e informe nome completo, CPF válido, telefone com DDD e e-mail válido quando preenchido.',
    waiting: 'Aguardando colaborador',
    received: 'Recebidas',
    analyzing: 'Em análise',
    payroll: 'Enviadas para a Folha',
    returned: 'Devolvidas',
    waitingDescription: 'Convite enviado, dados ainda não recebidos.',
    receivedDescription: 'O colaborador enviou os dados pelo aplicativo.',
    analyzingDescription: 'Conferência dos dados pelo escritório.',
    payrollDescription: 'Admissão entregue à Folha com protocolo.',
    returnedDescription: 'Aguardando correção do colaborador.',
    nothing: 'Nada por aqui.',
    startAnalysis: 'Iniciar análise',
    sendPayroll: 'Enviar para a Folha',
    returnCorrection: 'Devolver para correção',
    finishAdmission: 'Concluir admissão',
    return: 'Devolver',
    reason: 'Explique o que precisa ser corrigido.',
    reasonRequired: 'Informe o motivo da devolução.',
    contact: 'Contato',
    payrollProtocol: 'Protocolo da Folha',
    history: 'Histórico',
    documents: 'Documentos enviados',
    dependents: 'Dependentes',
    employeeData: 'Dados enviados pelo colaborador',
    admissionSent: 'Convite de admissão simulado.',
    analysisStarted: 'Escritório iniciou a conferência.',
    payrollSent: 'Envio simulado para a Folha.',
    admissionFinished: 'Admissão concluída na demonstração.',
    admissionReturned: 'Devolvida para correção.',
    ai: 'Domínio IA',
    hello: 'Olá',
    ask: 'Como posso ajudar você hoje?',
    send: 'Enviar',
    cashFlowRequest: 'Gerar o fluxo de caixa do cliente deste mês',
    batchRequest: 'Emitir em lote todas as notas dos meus clientes na competência',
    invoiceRequest: 'Emitir uma NFSe no valor de R$ 4.800,00',
    taxesRequest: 'Quais clientes têm imposto em atraso?',
    portfolioRequest: 'Resumo da carteira deste mês',
    bookkeepingRequest: 'Quem está com notas sem escrituração?',
    taxReply: 'Exemplo simulado: 1 cliente com INSS em atraso de R$ 4.210,00. Consulte a empresa para verificar os dados reais.',
    bookkeepingReply: 'Exemplo simulado: 3 notas de serviço ainda sem envio à escrituração. O fechamento vence em 4 dias.',
    portfolioReply: 'Exemplo simulado: R$ 21.705,00 vencidos a receber, R$ 4.210,00 de imposto em atraso e R$ 38.400,00 de saldo parado.',
    defaultReply: 'Posso demonstrar alertas, impostos, notas e recebimentos. Esta resposta é simulada.',
    batchSuccess: '30 NFSes emitidas na simulação',
    batchDetail: '3 clientes · R$ 128.450,00. Nenhuma nota foi emitida ou enviada à escrituração real.',
    invoiceSuccess: 'NFSe 1204 simulada',
    invoiceDetail: 'Desenvolvimento de software · R$ 4.800,00. Sem autorização fiscal real.',
    viewInvoice: 'Ver PDF',
    exportFlow: 'Exportar fluxo de caixa',
    flow: 'Fluxo de caixa projetado',
    initialBalance: 'Saldo inicial',
    inflows: 'Entradas',
    outflows: 'Saídas',
    projected: 'Saldo projetado',
    period: 'Período',
    negative: 'Caixa ficará negativo em 14/10',
    negativeDescription: 'Exemplo: folha e impostos deixam o saldo em −R$ 12.400,00 até os recebimentos do dia 17.',
    insightTax: 'INSS vencendo em 2 dias',
    insightTaxDescription: 'Exemplo: guia INSS de R$ 4.210,00. Pague pela Conta Digital após conferir os dados reais.',
    payNow: 'Pagar agora',
    insightDiscount: 'Desconto de 3% pagando à vista',
    insightDiscountDescription: 'Exemplo: desconto à vista pode economizar R$ 3.200,00 no mês.',
    payDiscount: 'Pagar com desconto',
    insightOverdue: '2 recebimentos em atraso',
    insightOverdueDescription: 'Exemplo: dois títulos somando R$ 17.705,00 vencidos há mais de 10 dias.',
    viewReceivables: 'Ver recebimentos',
    insightReform: 'Serviços sem enquadramento na Reforma',
    insightReformDescription: 'Exemplo: 18 serviços sem a classificação exigida pela Reforma Tributária.',
    reviewServices: 'Revisar serviços',
    insightDates: 'Pagamentos concentrados no início do mês',
    insightDatesDescription: 'Exemplo: 65% das contas vencem entre os dias 5 e 10, e 70% das entradas chegam após o dia 15.',
    viewDueDates: 'Ver vencimentos',
    anticipate: 'Antecipar recebíveis',
    accountingCode: 'Código da Empresa no Contábil',
    office: 'Escritório',
    demonstrationOffice: 'Escritório de demonstração',
};
const en = {
    configureNewClients: 'Configure new clients',
    cpf: 'CPF',
    pix: 'Pix',
    showDemo: 'View demo summary',
    summaryDemo: 'Demo financial summary — simulated amounts.',
    demonstration: 'Demo',
    toReview: 'To review',
    sentPayroll: 'Sent to payroll',
    attention: 'Attention',
    critical: 'Critical',
    insight: 'Insight',
    usersCount: 'registered users',
    saved: 'User registered in the demo.',
    invalidUser: 'Enter a name, an 11-digit CPF and a valid email.',
    search: 'Search by name or CNPJ…',
    notInvited: 'Not invited',
    invited: 'Invitation sent',
    active: 'Active',
    accountingInfo: 'Only companies registered in Accounting are listed here. Register missing companies in Domínio Contábil under Control / Companies, then return to send the invitation.',
    inviteStep: 'Step 1 — Invitation',
    configurationStep: 'Step 2 — Configuration',
    legalName: 'Legal representative name',
    invalidInvite: 'Enter the legal representative’s CPF, name, email and phone.',
    invitationSent: 'Simulated invitation. No email was sent.',
    waitConfirmation: 'After the legal representative confirms, configure the company in Domínio Empresa.',
    noResults: 'No companies found.',
    admissionDescription: 'Start an admission for a client company. The employee completes the data in the app and the response arrives here, ready for Payroll.',
    clientCompany: 'Client company',
    type: 'Admission type',
    employee: 'Employee',
    contributor: 'Contributor',
    intern: 'Intern',
    optionalEmail: 'Email (optional)',
    payment: 'Payment method',
    account: 'Bank account',
    cash: 'Cash',
    observation: 'Note for the employee',
    invalidAdmission: 'Select a company and enter a full name, valid CPF, phone with area code and a valid email if provided.',
    waitingDescription: 'Invitation sent, data not yet received.',
    receivedDescription: 'The employee submitted data through the app.',
    analyzingDescription: 'Office review of the data.',
    payrollDescription: 'Admission delivered to Payroll with a protocol.',
    returnedDescription: 'Waiting for employee corrections.',
    return: 'Return',
    reason: 'Explain what needs correcting.',
    reasonRequired: 'Enter a reason for the return.',
    payrollProtocol: 'Payroll protocol',
    employeeData: 'Data submitted by the employee',
    admissionSent: 'Simulated admission invitation.',
    analysisStarted: 'Office started the review.',
    payrollSent: 'Simulated submission to Payroll.',
    admissionFinished: 'Admission completed in the demo.',
    admissionReturned: 'Returned for correction.',
    cashFlowRequest: 'Generate this month’s client cash flow',
    batchRequest: 'Issue all my clients’ invoices in a batch for the period',
    invoiceRequest: 'Issue an NFSe for R$ 4,800.00',
    taxesRequest: 'Which clients have overdue taxes?',
    portfolioRequest: 'This month’s portfolio summary',
    bookkeepingRequest: 'Who has invoices pending bookkeeping?',
    taxReply: 'Simulated example: 1 client with R$ 4,210.00 in overdue INSS. Open the company to verify real data.',
    bookkeepingReply: 'Simulated example: 3 service invoices pending bookkeeping. Closing is due in 4 days.',
    portfolioReply: 'Simulated example: R$ 21,705.00 in overdue receivables, R$ 4,210.00 in overdue taxes and R$ 38,400.00 in idle funds.',
    defaultReply: 'I can demonstrate alerts, taxes, invoices and receipts. This response is simulated.',
    batchSuccess: '30 NFSes issued in the simulation',
    batchDetail: '3 clients · R$ 128,450.00. No invoice was issued or sent to real bookkeeping.',
    invoiceSuccess: 'Simulated NFSe 1204',
    invoiceDetail: 'Software development · R$ 4,800.00. No real fiscal authorization.',
    viewInvoice: 'View PDF',
    exportFlow: 'Export cash flow',
    flow: 'Projected cash flow',
    initialBalance: 'Opening balance',
    inflows: 'Inflows',
    outflows: 'Outflows',
    projected: 'Projected balance',
    period: 'Period',
    negative: 'Cash will be negative on 14/10',
    negativeDescription: 'Example: payroll and taxes leave a balance of −R$ 12,400.00 until receipts on the 17th.',
    insightTax: 'INSS due in 2 days',
    insightTaxDescription: 'Example: INSS payment of R$ 4,210.00. Pay through the Digital Account after checking real data.',
    payNow: 'Pay now',
    insightDiscount: '3% discount for immediate payment',
    insightDiscountDescription: 'Example: immediate payment can save R$ 3,200.00 this month.',
    payDiscount: 'Pay with discount',
    insightOverdue: '2 overdue receipts',
    insightOverdueDescription: 'Example: two items totaling R$ 17,705.00 overdue by more than 10 days.',
    viewReceivables: 'View receipts',
    insightReform: 'Services without Tax Reform classification',
    insightReformDescription: 'Example: 18 services missing the classification required by Tax Reform.',
    reviewServices: 'Review services',
    insightDates: 'Payments concentrated at the start of the month',
    insightDatesDescription: 'Example: 65% of bills are due between the 5th and 10th, and 70% of inflows arrive after the 15th.',
    viewDueDates: 'View due dates',
    anticipate: 'Advance receivables',
    accountingCode: 'Company code in Accounting',
    notice: 'Demo: simulated data and actions. No external operation will be performed.',
    users: 'Office users',
    newUser: 'New user',
    name: 'Name',
    fullName: 'Full name',
    email: 'Email',
    phone: 'Phone',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    company: 'Company',
    city: 'City',
    status: 'Status',
    actions: 'Actions',
    client: 'Client',
    all: 'All',
    select: 'Select',
    newAdmission: 'New admission',
    sendInvite: 'Send invitation',
    invite: 'Invite',
    resend: 'Resend',
    configure: 'Configure',
    waiting: 'Waiting for employee',
    received: 'Received',
    analyzing: 'Under review',
    payroll: 'Sent to payroll',
    returned: 'Returned',
    nothing: 'Nothing here.',
    startAnalysis: 'Start review',
    sendPayroll: 'Send to payroll',
    returnCorrection: 'Return for correction',
    finishAdmission: 'Complete admission',
    contact: 'Contact',
    history: 'History',
    documents: 'Submitted documents',
    dependents: 'Dependents',
    ai: 'Domínio AI',
    hello: 'Hello',
    ask: 'How can I help you today?',
    send: 'Send',
    office: 'Office',
    demonstrationOffice: 'Demo office',
};
const es = {
    configureNewClients: 'Configurar nuevos clientes',
    cpf: 'CPF',
    pix: 'Pix',
    showDemo: 'Ver resumen de demostración',
    summaryDemo: 'Resumen financiero de demostración — importes simulados.',
    demonstration: 'Demostración',
    toReview: 'Para analizar',
    sentPayroll: 'Enviadas a nómina',
    attention: 'Atención',
    critical: 'Crítico',
    insight: 'Insight',
    usersCount: 'usuarios registrados',
    saved: 'Usuario registrado en la demostración.',
    invalidUser: 'Ingrese nombre, CPF de 11 dígitos y correo válido.',
    search: 'Buscar por nombre o CNPJ…',
    notInvited: 'No invitada',
    invited: 'Invitación enviada',
    active: 'Activa',
    accountingInfo: 'Solo se muestran empresas registradas en Contabilidad. Registre las empresas que falten en Domínio Contábil, Control / Empresas, y vuelva para enviar la invitación.',
    inviteStep: 'Paso 1 — Invitación',
    configurationStep: 'Paso 2 — Configuración',
    legalName: 'Nombre del representante legal',
    invalidInvite: 'Ingrese CPF, nombre, correo y teléfono del representante legal.',
    invitationSent: 'Invitación simulada. No se envió ningún correo.',
    waitConfirmation: 'Después de la confirmación del representante legal, configure la empresa en Domínio Empresa.',
    noResults: 'No se encontraron empresas.',
    admissionDescription: 'Inicie una admisión para una empresa cliente. El colaborador completa los datos en la aplicación y la respuesta llega aquí, lista para Nómina.',
    clientCompany: 'Empresa cliente',
    type: 'Tipo de admisión',
    employee: 'Empleado',
    contributor: 'Contribuyente',
    intern: 'Pasante',
    optionalEmail: 'Correo (opcional)',
    payment: 'Forma de pago',
    account: 'Cuenta bancaria',
    cash: 'Efectivo',
    observation: 'Observación para el colaborador',
    invalidAdmission: 'Seleccione una empresa e ingrese nombre completo, CPF válido, teléfono con código de área y correo válido si se proporciona.',
    waitingDescription: 'Invitación enviada, datos aún no recibidos.',
    receivedDescription: 'El colaborador envió los datos por la aplicación.',
    analyzingDescription: 'Revisión de los datos por la oficina.',
    payrollDescription: 'Admisión entregada a Nómina con protocolo.',
    returnedDescription: 'Esperando correcciones del colaborador.',
    return: 'Devolver',
    reason: 'Explique qué debe corregirse.',
    reasonRequired: 'Ingrese el motivo de la devolución.',
    payrollProtocol: 'Protocolo de Nómina',
    employeeData: 'Datos enviados por el colaborador',
    admissionSent: 'Invitación de admisión simulada.',
    analysisStarted: 'La oficina inició la revisión.',
    payrollSent: 'Envío simulado a Nómina.',
    admissionFinished: 'Admisión concluida en la demostración.',
    admissionReturned: 'Devuelta para corrección.',
    cashFlowRequest: 'Generar el flujo de caja del cliente de este mes',
    batchRequest: 'Emitir en lote todas las notas de mis clientes del período',
    invoiceRequest: 'Emitir una NFSe por R$ 4.800,00',
    taxesRequest: '¿Qué clientes tienen impuestos atrasados?',
    portfolioRequest: 'Resumen de la cartera de este mes',
    bookkeepingRequest: '¿Quién tiene notas pendientes de contabilización?',
    taxReply: 'Ejemplo simulado: 1 cliente con INSS atrasado por R$ 4.210,00. Consulte la empresa para verificar los datos reales.',
    bookkeepingReply: 'Ejemplo simulado: 3 notas de servicio pendientes de contabilización. El cierre vence en 4 días.',
    portfolioReply: 'Ejemplo simulado: R$ 21.705,00 en cobros vencidos, R$ 4.210,00 en impuestos atrasados y R$ 38.400,00 en fondos inactivos.',
    defaultReply: 'Puedo demostrar alertas, impuestos, notas y cobros. Esta respuesta es simulada.',
    batchSuccess: '30 NFSes emitidas en la simulación',
    batchDetail: '3 clientes · R$ 128.450,00. No se emitió ninguna nota ni se envió a la contabilidad real.',
    invoiceSuccess: 'NFSe 1204 simulada',
    invoiceDetail: 'Desarrollo de software · R$ 4.800,00. Sin autorización fiscal real.',
    viewInvoice: 'Ver PDF',
    exportFlow: 'Exportar flujo de caja',
    flow: 'Flujo de caja proyectado',
    initialBalance: 'Saldo inicial',
    inflows: 'Entradas',
    outflows: 'Salidas',
    projected: 'Saldo proyectado',
    period: 'Período',
    negative: 'La caja quedará negativa el 14/10',
    negativeDescription: 'Ejemplo: nómina e impuestos dejan el saldo en −R$ 12.400,00 hasta los cobros del día 17.',
    insightTax: 'INSS vence en 2 días',
    insightTaxDescription: 'Ejemplo: pago INSS de R$ 4.210,00. Pague por la Cuenta Digital después de verificar los datos reales.',
    payNow: 'Pagar ahora',
    insightDiscount: 'Descuento del 3% por pago inmediato',
    insightDiscountDescription: 'Ejemplo: el pago inmediato puede ahorrar R$ 3.200,00 este mes.',
    payDiscount: 'Pagar con descuento',
    insightOverdue: '2 cobros atrasados',
    insightOverdueDescription: 'Ejemplo: dos títulos por R$ 17.705,00 vencidos hace más de 10 días.',
    viewReceivables: 'Ver cobros',
    insightReform: 'Servicios sin clasificación de la Reforma',
    insightReformDescription: 'Ejemplo: 18 servicios sin la clasificación exigida por la Reforma Tributaria.',
    reviewServices: 'Revisar servicios',
    insightDates: 'Pagos concentrados al inicio del mes',
    insightDatesDescription: 'Ejemplo: el 65% de las cuentas vence entre los días 5 y 10 y el 70% de las entradas llega después del día 15.',
    viewDueDates: 'Ver vencimientos',
    anticipate: 'Anticipar cuentas por cobrar',
    accountingCode: 'Código de empresa en Contabilidad',
    notice: 'Demostración: datos y acciones simulados. No se realizará ninguna operación externa.',
    users: 'Usuarios de la oficina',
    newUser: 'Nuevo usuario',
    name: 'Nombre',
    fullName: 'Nombre completo',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    cancel: 'Cancelar',
    save: 'Guardar',
    close: 'Cerrar',
    company: 'Empresa',
    city: 'Ciudad',
    status: 'Estado',
    actions: 'Acciones',
    client: 'Cliente',
    all: 'Todos',
    select: 'Seleccione',
    newAdmission: 'Nueva admisión',
    sendInvite: 'Enviar invitación',
    invite: 'Invitar',
    resend: 'Reenviar',
    configure: 'Configurar',
    waiting: 'Esperando colaborador',
    received: 'Recibidas',
    analyzing: 'En análisis',
    payroll: 'Enviadas a nómina',
    returned: 'Devueltas',
    nothing: 'Nada por aquí.',
    startAnalysis: 'Iniciar análisis',
    sendPayroll: 'Enviar a nómina',
    returnCorrection: 'Devolver para corrección',
    finishAdmission: 'Concluir admisión',
    contact: 'Contacto',
    history: 'Historial',
    documents: 'Documentos enviados',
    dependents: 'Dependientes',
    ai: 'Domínio IA',
    hello: 'Hola',
    ask: '¿Cómo puedo ayudarte hoy?',
    send: 'Enviar',
    office: 'Oficina',
    demonstrationOffice: 'Oficina de demostración',
};
export const demoTranslations = { 'pt-BR': pt, 'en-US': en, 'es-ES': es };
